import { Typography } from '@material-tailwind/react'

export const ResultObservations = ({ observations }) => {
  if (!observations) return null

  return (
    <div className="mt-4 p-2 border-l-4 border-blue-400 bg-blue-50">
      <Typography
        variant="small"
        className="text-sm text-blue-700 whitespace-pre-line"
      >
        {observations}
      </Typography>
    </div>
  )
}
